import { BaseDto } from '../../core';
import { INQUIRY_TYPE } from '../../shared';
import { Product, PurchaseOrder, FileAttachmentDto, Buyer } from '..';

export enum INQUIRY_REFERENCE_TYPE {
  PRODUCT = 'PRODUCT',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
}

export class Inquiry extends BaseDto<Inquiry> {
  constructor(partial?: any) {
    super(partial);
  }
  id: number;
  subject: string;
  contents: string;
  attachments?: FileAttachmentDto[];
  inquiryType: INQUIRY_TYPE;
  adminId: number;
  referenceType: INQUIRY_REFERENCE_TYPE;
  referenceId: number;
  hasQuestion: boolean;
  isClosed: boolean;
  isReply: boolean;
  lastQuestioned: Date | null;
  lastAnswered: Date | null;
  inquiry?: Inquiry;
  replies?: Inquiry[];
  product?: Product;
  userAgent: string;
  purchaseOrder?: PurchaseOrder;
  deleted: Date | null;
  closed: Date | null;
  created: Date;
  buyer: Buyer;
}
